var map = {
	"./logo1.png": 54221,
	"./logo2.png": 18305,
	"./logo3.png": 46307,
	"./logo4.png": 41875,
	"./logo5.png": 74596,
	"./logo6.png": 76152,
	"./logo7.png": 18538,
	"./logo8.png": 29398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46457;